<template>
  <div class="error-message">
    <h3 class="error-message-heading">
      <slot name="header">{{ $t('error-message.default-heading') }}</slot>
    </h3>
    <slot>
      <p>{{ $t('error-message.unknown-error-message') }}</p>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
}
</script>

<style lang="scss" scoped>
.error-message {
  margin: 1em auto;
  text-align: center;
  color: $errorText;

  > .error-message-heading {
    color: inherit; // Override the default heading color from the global Fessor style
  }
}
</style>
